export default "__VITE_ASSET__DhegVzhu__"